import { IAdmin } from 'src/commons';
import { AdminActionTypes, AdminActions } from './admin.actions';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IAdmin | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: AdminActions): State {
    switch (action.type) {

        case AdminActionTypes.LoadAdminState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case AdminActionTypes.LoadAdminStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case AdminActionTypes.LoadAdminStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case AdminActionTypes.AdminScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;